import { Injectable, EventEmitter } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ContactUsEventHandlerService {
  contactUsEvent = new EventEmitter<void>();
}
